import { createContext } from 'react';

var TableContext = /*#__PURE__*/createContext({
  clearFilters: function clearFilters() {},
  dispatch: function dispatch() {},
  filtered: [],
  isAllSelected: false,
  isRowSelected: function isRowSelected() {
    return false;
  },
  isSelectable: false,
  rowIdentifier: 'id',
  selected: []
});

export default TableContext;
